(function() {
    'use strict';

    angular.module('caffeprint')
        .controller('LayoutController', LayoutController);

    LayoutController.$inject = [];

    function LayoutController() {
        var self = this;
    }
})();
